import React from 'react'

import { NOOP } from 'constants/commonConstans'
import { BrandFormEnum } from 'services/Branding/types'

import ReflectionFormFont from './ReflectionFormFont'
import ReflectionFormStyle from './ReflectionFormStyle'
import type { ReflectionBrandForms, ReflectionFormBrandType } from './reflectionTypes'

const FORM_MAP: ReflectionBrandForms = {
  [BrandFormEnum.STYLE]: ReflectionFormStyle,
  ...(ReflectionFormFont as ReflectionBrandForms),
}

const ReflectionFormBrand: ReflectionFormBrandType = (props) => {
  const Form = FORM_MAP[props.form] || NOOP
  return <Form {...props} />
}

export default React.memo(ReflectionFormBrand) as typeof ReflectionFormBrand
